import VehicleDetailsWeb from 'src/@carketa/vehicle_dialog/components/views/vehicle_sales_packet/VehicleDetailsWeb';

type VehicleDetailsSectionProps = {
  vehicle: any;
  setSalesLeadOpen?: any;
};

const VehicleDetailsSection = ({
  vehicle,
  setSalesLeadOpen,
}: VehicleDetailsSectionProps) => {
  return (
    <div id="vehicle-details-section" className="mt-2 mb-5 w-full">
      <div style={{ overflowX: 'auto' }}>
        <VehicleDetailsWeb
          vehicle={vehicle}
          setSalesLeadOpen={setSalesLeadOpen}
        />
      </div>
    </div>
  );
};

export default VehicleDetailsSection;
